module.exports = __webpack_public_path__ + "bo.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bo.svg
// module id = 714
// module chunks = 0